import './survey_item_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.ScoreItemChartView extends Monitoring.Views.Charts.SurveyItemChartView
  className: 'processing item'
  template: JST['backbone/templates/monitoring/charts/generic_chart']
  scoreTemplate: JST['backbone/templates/monitoring/charts/score_chart']

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    @facets = @options.facets
    @_settings = @options.settings
    @title = @_settings.name
    @terms = @_itemTerms(@facets.cem_surveys[0], @_settings.code)
    @minScore = 1
    @maxScore = 5

  render: ->
    @$el.html @template
      title: @title
    @trigger('masonry')
    @

  afterAppend: ->
    @$el.removeClass('processing')
    @data = @parseData()

    averageScore = @averageScore()

    @$el.find('.chart').html @scoreTemplate
      average: averageScore
      percentage: @starPercentage(averageScore)

    @$el.find('.chart').append(new Monitoring.Views.Charts.HorizontalBarChartView({data: @data}).render().el)

  parseData: ->
    scores = @initializeScores()
    _.each(@terms, (score) ->
      index = _.findIndex(scores, {code: parseInt(score.term)})
      scores[index].y = parseInt(score.count)
    )
    scores.reverse() # Sort from max score to min score

  initializeScores: ->
    scores = []
    for i in [@minScore..@maxScore]
      scores.push {code: i, y: 0, color: '#ff9800'}
    scores

  averageScore: ->
    total = 0
    acumScore = 0
    for score in @data
      total += score.y
      acumScore += score.code * score.y
    if total > 0 then (acumScore / total).toFixed(1) else 0

  starPercentage: (average) ->
    average * 100 / @maxScore
